import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'abs'})
export class AbsPipe implements PipeTransform {
  transform(input: any): number {
    return Math.abs(Number(input));
  }
}
